import { render, staticRenderFns } from "./ComprasFilaAtualizacao.vue?vue&type=template&id=78c068e6&scoped=true"
import script from "./ComprasFilaAtualizacao.vue?vue&type=script&lang=js"
export * from "./ComprasFilaAtualizacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c068e6",
  null
  
)

export default component.exports